/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-06-29 17:52:36
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2024-12-25 13:50:18
 */
import { getBusinessList } from "@/service/api/prompt.js";
import http from "@/service/httpConfig";
import {
  languageList,
  getCurrentList,
} from "@/service/api/internationalization";
import { local_or_azure } from "@/service/api/staticResourceUpload.js";
import { getKey } from "@/service/api/login";
const actions = {
  set_token({ commit }, token_info) {
    commit("set_token", token_info);
  },
  set_userData({ commit }, value) {
    commit("set_userData", value);
  },
  set_currentCompany({ commit }, value) {
    commit("set_currentCompany", value);
  },
  set_sideMenu({ commit }, value) {
    commit("set_sideMenu", value);
  },
  async set_sys_upload_type({ commit }, value) {
    // let obj = {
    //   'le.server.url': "http://192.168.0.110:9988",
    //   'file_upload_method': "azure",
    //   'local.dir': "D:/mrc/server/file"
    // }
    // commit('set_sys_upload_type', obj);
    const res = await local_or_azure();
    if (res.code == 200) {
      commit("set_sys_upload_type", res.data);
    }
  },
  // async set_topcompanylist ({ state, commit }, value) {
  //   const res = await getBusinessList({ prompt_name: 'client-levels', CLIENT_UUID: state.userData.clientUuid })
  //   if (res.code == 200) {
  //     commit('set_topcompanylist', res.data)
  //   }
  // },
  // async getPromptData ({ }, value) {
  //   const res = await getBusinessList(value)
  //   if (res.code == 200) {
  //     return res.data
  //   }
  // },
  async set_topcompanylist({ state, commit }, value) {
    const res = await http.post("/api/company/relation-company/v1", {
      "~table~": "mrbase_sys_org_levels",
    });
    if (res.code == 200) {
      if (Array.isArray(res.data)) {
        const uuids = res.data.map((item) => item.uuid);
        if (!uuids.includes(state.currentCompanyObj.uuid)) {
          commit("set_topcompanylist", res.data);
          commit("set_currentCompanyClientUuid", res.data[0].client_uuid || "");
          commit("setCurrentCompanyObj", res.data[0]);
        }
      } else {
        if (res.data.uuid != state.currentCompanyObj.uuid) {
          commit("set_topcompanylist", [res.data]);
          commit(
            "set_currentCompanyClientUuid",
            [res.data][0].client_uuid || ""
          );
          commit("setCurrentCompanyObj", res.data);
        }
      }
    }
  },
  // 查找该公司有几种国际化语言
  async setCurrentCompanyLanguageList({ state, commit, getters }, value) {
    const res = await languageList({
      org_level_uuid: state.userData.org_level_uuid || "",
    });
    if (res.code == 200) {
      commit("setCurrentCompanyLanguage", res.data);
    } else {
      commit("setCurrentCompanyLanguage", []);
    }
  },
  // async setAllLanguageList ({ commit }) {
  //   const res = await languageList()
  //   if (res.code == 200) {
  //     commit('setAllLanguage', res.data.Data)
  //   }
  //   commit('setAllLanguage', [])
  // },
  // 查找公司的所有语言label
  async set_languageList({ commit }, value) {
    const res = await getCurrentList();
    if (res.code == 200) {
      commit("set_languageList", res.data.values);
    }
  },
  async setPubk({ commit }) {
    const res = await getKey();
    commit("setPubk", res.data);
    return res.data;
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

export default actions;
